/**
 * LinkExpired — landing page reached when a Supabase magic link has expired.
 *
 * Supabase appends `#error=access_denied&error_description=...expired...` to
 * the redirect URL when the token is past its 60-minute window. The hash
 * sniffer in App.tsx detects that and navigates here.
 *
 * Brand: cream #FAFAF7 background, ink #0B0B0F headline, red #DC2626 CTA.
 * Headline uses DM Sans (font-display); body uses Inter.
 */
import { useLocation } from "wouter";
import { Button } from "@/components/ui/button";

export default function LinkExpired() {
  const [, setLocation] = useLocation();

  function requestNewLink() {
    setLocation("/login");
  }

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#FAFAF7",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "24px",
        fontFamily: "Inter, system-ui, sans-serif",
        color: "#0B0B0F",
      }}
    >
      <div
        style={{
          maxWidth: 440,
          width: "100%",
          background: "#FFFFFF",
          border: "1px solid rgba(15,23,42,0.08)",
          borderRadius: 16,
          padding: "32px 28px",
          boxShadow: "0 1px 2px rgba(15,23,42,0.04)",
          textAlign: "center",
        }}
      >
        <h1
          className="font-display"
          style={{
            fontFamily: "'DM Sans', Inter, system-ui, sans-serif",
            fontSize: 22,
            fontWeight: 700,
            letterSpacing: "-0.01em",
            margin: 0,
            marginBottom: 12,
            color: "#0B0B0F",
          }}
        >
          This link has expired
        </h1>
        <p
          style={{
            fontSize: 14,
            lineHeight: 1.55,
            color: "#52525B",
            margin: 0,
            marginBottom: 24,
          }}
        >
          Magic links expire after 60 minutes. Request a new one to sign in.
        </p>
        <Button
          onClick={requestNewLink}
          style={{
            background: "#DC2626",
            color: "#FAFAF7",
            border: "none",
            padding: "10px 20px",
            fontSize: 13,
            fontWeight: 600,
            borderRadius: 8,
            cursor: "pointer",
            width: "100%",
          }}
        >
          Request new link
        </Button>
      </div>
    </div>
  );
}
